import { Route } from '@framework/ui';
import React from 'react';
import { Switch } from 'react-router';
import { AddressBookPage } from './AddressBookPage';

export default function AddressBookRoutes() {
  return (
    <Switch>
      <Route
        path="/rubrica/richieste/:id/deleghe"
        component={AddressBookPage}
      />
      <Route path="/rubrica" component={AddressBookPage} exact />
    </Switch>
  );
}
